/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskRubricV2Input } from './taskRubricV2Input';

export type TaskUpdateRequestRubric = TaskRubricV2Input | null;
